const buildMessageByParams = (sourceMessage, params = {}) => {
  for (const [key, value] of Object.entries(params)) {
    sourceMessage = sourceMessage.replace(new RegExp(`{{${key}}}`, "g"), value);
  }

  return sourceMessage;
};

export { buildMessageByParams };
